export const APP_ORDERS_IN_PAST = [1, 2, 3, 4, 5, 6];
